import React from "react";
import { Icon } from "@iconify/react";

const GameStatsIndicator = ({ score = 0, timeLeft = 300 }) => {
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  const isLowTime = timeLeft < 30;

  return (
    <div className="absolute top-4 right-4 z-[9999] pointer-events-none select-none">
      <div className="flex items-center gap-3 px-4 py-2.5 rounded-2xl bg-black/60 backdrop-blur-md border border-white/10 shadow-2xl transition-all duration-300">
        {/* Score Block */}
        <div className="flex items-center gap-2 pr-3 border-r border-white/10">
          <div className="p-1.5 bg-yellow-500/10 text-yellow-400 rounded-lg">
            <Icon icon="solar:medal-star-bold" className="w-4 h-4" />
          </div>
          <div className="flex flex-col">
            <span className="text-[9px] text-white/50 font-bold uppercase tracking-wider leading-none">Score</span>
            <span className="text-sm font-extrabold text-white leading-none mt-0.5">{score}</span>
          </div>
        </div>

        {/* Time Block */}
        <div className="flex items-center gap-2">
          <div className={`p-1.5 rounded-lg transition-colors duration-300 ${
            isLowTime ? "bg-rose-500/20 text-rose-400 animate-pulse" : "bg-emerald-500/10 text-emerald-400"
          }`}>
            <Icon icon="solar:alarm-bold" className="w-4 h-4" />
          </div>
          <div className="flex flex-col">
            <span className="text-[9px] text-white/50 font-bold uppercase tracking-wider leading-none">Time Left</span>
            <span className={`text-sm font-extrabold leading-none mt-0.5 transition-colors duration-300 ${
              isLowTime ? "text-rose-400 font-black" : "text-white"
            }`}>
              {formatTime(timeLeft)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GameStatsIndicator;
